import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleAircraft } from "./Constant/Source";
import AircraftCreateForm from "./Forms/AircraftCreateForm";

const AircraftCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleAircraft.create}>
      <SimpleForm>
        <AircraftCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default AircraftCreate;
